module.exports = __webpack_public_path__ + "92a03bf770fc05fc14bcbb2be584aa2f.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_mini-adventure.png
// module id = 176
// module chunks = 0